import React, { Component } from 'react';
import API from 'API';
import Loader from 'components/common/Loader';
import TextHelpers from 'helpers/TextHelpers';

//-------------------------------------------------------------------------------------------------------------------

class ConfirmPrice extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { onBackClicked, onNextClicked, accountInfo } = this.props;

        return (<>

            <h2>Your Price Estimate</h2>

            <p className="subtitle">
                Your estimated sweep price is
            </p>
            <p className="est-price">
                {TextHelpers.formatCurrency(accountInfo.sweepPrice)}
                {accountInfo.isVATRegistered &&
                    <span className="including-vat">Including VAT</span>
                }
            </p>
            <p className="subtitle">
                This assumes a standard single-chimney sweep with no blockages (such as nests).
                <br /><br />
                <a className="btn mt-3" href={'tel:' + (accountInfo.landlineTel || '').replace(/[^0-9]/g, '')}>
                    If you need a nest removed or cowl fitted, <br />
                    or have multiple chimneys to sweep, <br />
                    please call us on {accountInfo.landlineTel}
                </a>
            </p>

            <div className="nav-buttons">
                
                <button
                    type="button"
                    className="btn btn-secondary me-auto"
                    onClick={() => onBackClicked()}
                >
                    Back
                </button>

                <button type="button" className="btn ms-auto" onClick={() => onNextClicked()}>
                    Next
                </button>

            </div>

        </>);
    }
    
}

export default ConfirmPrice;